import _ from 'underscore';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';

const i18n = globalContext.require('@bingads-webui/i18n-amd-loader!campaignui/feature/hotel-center');

const ERROR_MAP = {
  BulkEditActionsForDifferentEntities: 'HotelCenter_Overview_Bulk_Errormsg_DifferentEntities',
  InternalError: 'HotelCenter_Overview_Bulk_Errormsg_InternalError',
  default: 'HotelCenter_Overview_Bulk_Errormsg_Default',
};


export function parseErrors(response) {
  const errors = response.errors.map((error) => {
    const errorI18nKey = _.result(ERROR_MAP, error.Code, ERROR_MAP.default);
    return i18n.getString(errorI18nKey);
  });

  return errors;
}
